import { useState } from "react";
import { Link } from "react-router-dom";
import API_BASE_URL from '../config';
import '../styles/auth.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const apiRoot = API_BASE_URL.replace(/\/api\/?$/, '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Ju lutem shkruani email-in tuaj.");
      return;
    }
    setError("");
    setMessage("");
    setIsLoading(true);

    try {
      const res = await fetch(`${apiRoot}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        setMessage(data.message || "Një link për ndryshimin e fjalëkalimit u dërgua.");
      } else {
        setError(data.message || "Ndodhi një gabim gjatë dërgimit të kërkesës.");
      }
    } catch (err) {
      setError("Ndodhi një gabim me lidhjen.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-icon-badge">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        <h2 className="auth-title">Keni harruar fjalëkalimin?</h2>
        <p className="auth-sub">Shkruani email-in e lidhur me llogarinë tuaj dhe ne do t'ju dërgojmë një link për të krijuar një fjalëkalim të ri.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <input 
            className="auth-input" 
            placeholder="Email adresë" 
            type="email"
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
          />
          
          <button type="submit" className="auth-submit" disabled={isLoading}>
            {isLoading ? "Duke dërguar..." : "Dërgo Linkun"}
          </button>

          {error && <div className="auth-error">{error}</div>}
          {message && <div className="auth-message">{message}</div>}

          <div className="auth-footer">
            Kthehu te <Link to="/login" className="auth-link-btn">Kyçja</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
